// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import headersWithAuth0Token from "helpers/headersWithAuth0Token";

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_SERVER_BASE_URL}`,
    prepareHeaders: headersWithAuth0Token,
  }),

  endpoints: () => ({}),
});
